// src/lib/fiscalYear.ts (2026-09-07)
// 年度 (4月始まり) の月枠と、サイドバー「開始月 / 終了月」(store の periodFrom / periodTo) の解釈。
// 入院実績(前年度・予算比較) と 行為別売上 で共有する (両タブは同じ期間コントロール・同じ年度枠)。
//   - 年度 = 最新確定月 (meta.dateMax) の年度に固定。前年度は同じ月の 12 ヶ月前で比べる。
//   - 期間 (開始月〜終了月) は年度内の月番号だけで指定し、月平均の対象月を決める。

export const FY_MONTHS = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];

/** "YYYY-MM-DD" → 年度 (4月〜翌3月)。3月までは前年の年度 */
export function fiscalYearOf(yyyymmdd: string): number {
  const [y, m] = yyyymmdd.split("-").map(Number);
  return m >= 4 ? y : y - 1;
}

/** 年度 fy の month 月 → "YYYY-MM-01" */
export function fyDate(fy: number, month: number): string {
  const y = month >= 4 ? fy : fy + 1;
  return `${y}-${String(month).padStart(2, "0")}-01`;
}

/** 年度 fy の 12 ヶ月 ("YYYY-MM-01"・4月始まり) */
export function fyMonthDates(fy: number): string[] {
  return FY_MONTHS.map((m) => fyDate(fy, m));
}

/** 月ラベル: 4月と1月 (年度初・西暦切替) だけ "26/4月" と年を添え、他は "5月" */
export function monthLabel(date: string): string {
  const [y, m] = date.split("-");
  const mi = Number(m);
  return mi === 4 || mi === 1 ? `${y.slice(2)}/${mi}月` : `${mi}月`;
}

/** 開始月〜終了月 (年度内の月番号で解釈・逆順でも可) に含まれる "YYYY-MM-01" の集合 */
export function selectedMonthDates(fy: number, fromDate: string, toDate: string): Set<string> {
  const fromIdx = FY_MONTHS.indexOf(Number(fromDate.slice(5, 7)));
  const toIdx = FY_MONTHS.indexOf(Number(toDate.slice(5, 7)));
  const lo = Math.min(fromIdx, toIdx);
  const hi = Math.max(fromIdx, toIdx);
  return new Set(FY_MONTHS.slice(lo, hi + 1).map((m) => fyDate(fy, m)));
}

/** 期間ラベル "4月〜7月" */
export function selectedRangeLabel(fromDate: string, toDate: string): string {
  return `${Number(fromDate.slice(5, 7))}月〜${Number(toDate.slice(5, 7))}月`;
}
